module.exports = __webpack_public_path__ + "static/media/about1.3fbc9af9.jpg";